import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
import { isEmpty } from '@/utils';
export default {
  name: 'scan_config',
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      rules: {
        imageurl: [{
          required: true,
          message: '图片不可为空'
        }]
      },
      showPictureLibrary: false,
      depot: {},
      pictureList: []
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config['imageurl'] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture() {
      this.showPictureLibrary = true;
    },
    upload: function upload() {
      this.$refs.uploadBanner.uploadBanner();
    },
    emitUploadFile: function emitUploadFile(url) {
      this.$set(this.value.config, 'imageurl', "".concat(this.$ossurl).concat(url));
    },
    deleteImg: function deleteImg() {
      var _this2 = this;
      if (!this.value.config.imageurl) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this2.value.config.imageurl = '';
      });
    }
  },
  created: function created() {
    if (isEmpty(this.value.config)) {
      this.$set(this.value, 'config', JSON.parse(JSON.stringify(this.value.config_default_value)));
    }
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_,
      _this$value$config$bi = _this$value$config.bind_card_mode,
      bind_card_mode = _this$value$config$bi === void 0 ? 1 : _this$value$config$bi;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index,
      //兼容新老组件 默认预置2
      bind_card_mode: bind_card_mode //兼容新老组件 默认预置1
    }));
    this.getPicture();
  }
};